import { TSetupChargeRequestState, TSetupChargeRequestType, TSetupChargeStatus } from "../../../shared/services/api/setupCharge/Types";

/**
 * Traduções e cores dos status da Taxa Setup Avulsa. Ficam neste módulo (e não nos utilitários globais)
 * para não alterar a tela atual de Setup, que usa os mesmos nomes de status com outro significado.
 */
type TChipColor = "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning";

export const SETUP_CHARGE_STATUS_LABEL: Record<TSetupChargeStatus, string> = {
	processing: "Processando",
	pending: "Aberta",
	paid: "Paga",
	failed: "Falhou",
	canceled: "Cancelada",
	expired: "Expirada",
};

export const SETUP_CHARGE_STATUS_COLOR: Record<TSetupChargeStatus, TChipColor> = {
	processing: "warning",
	pending: "info",
	paid: "success",
	failed: "error",
	canceled: "default",
	expired: "secondary",
};

export const SETUP_CHARGE_REQUEST_STATE_LABEL: Record<TSetupChargeRequestState, string> = {
	received: "Recebida",
	processing: "Processando",
	completed: "Concluída",
	rejected: "Recusada",
	dead: "Com falha",
};

export const setupChargeStatusLabel = (status?: string): string => SETUP_CHARGE_STATUS_LABEL[status as TSetupChargeStatus] ?? status ?? "";

export const setupChargeStatusColor = (status?: string): TChipColor => SETUP_CHARGE_STATUS_COLOR[status as TSetupChargeStatus] ?? "default";

export const SETUP_CHARGE_STATUS_OPTIONS: { value: TSetupChargeStatus; label: string }[] = (Object.keys(SETUP_CHARGE_STATUS_LABEL) as TSetupChargeStatus[]).map((value) => ({
	value,
	label: SETUP_CHARGE_STATUS_LABEL[value],
}));

export const SETUP_CHARGE_REQUEST_STATE_COLOR: Record<TSetupChargeRequestState, TChipColor> = {
	received: "info",
	processing: "warning",
	completed: "success",
	rejected: "error",
	dead: "error",
};

export const setupChargeRequestStateLabel = (state?: string): string => SETUP_CHARGE_REQUEST_STATE_LABEL[state as TSetupChargeRequestState] ?? state ?? "";

export const setupChargeRequestStateColor = (state?: string): TChipColor => SETUP_CHARGE_REQUEST_STATE_COLOR[state as TSetupChargeRequestState] ?? "default";

export const SETUP_CHARGE_REQUEST_TYPE_LABEL: Record<TSetupChargeRequestType, string> = {
	CREATE: "Criação",
	CANCEL: "Cancelamento",
	RESEND: "Reenvio do link",
	CONTACT_UPDATE: "Correção de contato",
};

export const setupChargeRequestTypeLabel = (type?: string): string => SETUP_CHARGE_REQUEST_TYPE_LABEL[type as TSetupChargeRequestType] ?? type ?? "";

export const SETUP_CHARGE_EVENT_LABEL: Record<string, string> = {
	REQUEST_RECEIVED: "Solicitação recebida",
	REQUEST_COMPLETED: "Solicitação concluída",
	REQUEST_REJECTED: "Solicitação recusada",
	REQUEST_DEAD: "Solicitação esgotou as tentativas",
	CREATED: "Cobrança criada",
	LINK_GENERATED: "Link de pagamento gerado",
	PAID: "Pagamento confirmado",
	DUPLICATE_PAYMENT: "Pagamento em duplicidade",
	MANUAL_PAYMENT: "Baixa manual",
	CANCELED: "Cobrança cancelada",
	EXPIRED: "Cobrança expirada",
	FAILED: "Cobrança falhou",
	RESENT: "Link reenviado",
	CONTACT_UPDATED: "Contato corrigido",
	REPASSED: "Repasse registrado",
	REPROCESSED: "Cobrança reprocessada",
};

export const setupChargeEventLabel = (eventType?: string): string => SETUP_CHARGE_EVENT_LABEL[eventType ?? ""] ?? eventType ?? "";

export const SETUP_CHARGE_SOURCE_LABEL: Record<string, string> = {
	partner: "Parceiro",
	panel: "Painel",
	system: "Sistema",
};

export const setupChargeSourceLabel = (source?: string): string => SETUP_CHARGE_SOURCE_LABEL[source ?? ""] ?? source ?? "";

export const SETUP_CHARGE_FEE_PAYER_LABEL: Record<string, string> = {
	payer: "Pagador",
	client: "Imobiliária",
	garantti: "Garantti",
};

export const setupChargeFeePayerLabel = (feePayer?: string | null): string => SETUP_CHARGE_FEE_PAYER_LABEL[feePayer ?? ""] ?? feePayer ?? "";

export const SETUP_CHARGE_PAYMENT_METHOD_LABEL: Record<string, string> = {
	PIX: "PIX",
	BOLETO: "Boleto",
	CREDIT_CARD: "Cartão de crédito",
	UNDEFINED: "A definir",
};

export const setupChargePaymentMethodLabel = (method?: string | null): string => (method ? SETUP_CHARGE_PAYMENT_METHOD_LABEL[method.toUpperCase()] ?? method : "");
